module.exports = __webpack_public_path__ + "img/section7.b53078e0.png";